import { createFileRoute } from "@tanstack/react-router";

import { WHAT_IS_MCP_FAQS } from "@/components/Mcp/mcpArticleFaqs";
import { MCP_ARTICLES } from "@/components/Mcp/mcpArticles";
import { mcpArticleHead } from "@/components/Mcp/mcpHead";
import { McpWhatIsMcpPage } from "@/components/Mcp/McpWhatIsMcpPage";

const article = MCP_ARTICLES.find(
  (a) => a.slug === "what-is-mcp-for-designers",
)!;

export const Route = createFileRoute("/mcp/what-is-mcp-for-designers")({
  component: McpWhatIsMcpPage,
  head: () =>
    mcpArticleHead({
      title: article.metaTitle,
      description: article.metaDescription,
      path: "/mcp/what-is-mcp-for-designers",
      breadcrumbName: article.name,
      faqs: WHAT_IS_MCP_FAQS,
    }),
});
